const API_PATH_PREFIX = '/api-workspace/v1/'

/**
 * Select schemas persist an absolute `data.url` built from the API root of the environment the form was
 * edited in. After copying data between environments (e.g. live -> stage) that origin is wrong, so
 * requests to our API path are always pointed at the current API root.
 */
export function resolveApiUrl(url: string): string {
  try {
    const parsed = new URL(url)

    if (!parsed.pathname.startsWith(API_PATH_PREFIX)) {
      return url
    }

    return new URL(`${parsed.pathname}${parsed.search}`, import.meta.env.VITE_API_ROOT).toString()
  } catch {
    return url
  }
}
